import React from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import { useParams } from 'react-router-dom';
import { useProductCategoriesForAction } from '../../../hooks/store/productCategory';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import EmptyData from '../../../components/ui/EmptyData';
import CategoriesListTable from '../../../components/store/category/CategoryListTable';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

function StoreCategoriesOverView() {
    const {t} = useTranslation();
    const { storeId} = useParams<{ storeId: string}>();
    const numericStoreId = storeId ? parseInt(storeId) : undefined;

    const {data,isError,isLoading} = useProductCategoriesForAction(numericStoreId);
  return (
    <Layout title={t('categories')} headline=''>
        <div className='flex justify-end'>
            <PermissionGate permissions={[PermissionsKey.CreateStoreCategory]}>
              <PrimaryButtonWithIconAdd
              buttonLabel="add_new_category"
              buttonLinkPath={numericStoreId? `/admin/stores/${numericStoreId}/add-category` :"/store/add-category"}
              />
            </PermissionGate>
         </div>
         <LoadingErrorState
         isError={isError}
         isLoading={isLoading}
         />
        {
        data && (
          data.length === 0 ?<EmptyData/> : <CategoriesListTable catgeories={data}/>
        )
        }
    </Layout>
  )
}

export default StoreCategoriesOverView